module.exports = __webpack_public_path__ + "static/media/Major Project ETRX 2018-19.8628e922.pdf";